import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { LayoutDashboard, ListOrdered, Settings, LogOut, Webhook } from 'lucide-react';
import { useMerchantAuth } from '../contexts/MerchantAuthContext';
import { toast } from 'sonner';
import EnvironmentBadge from './EnvironmentBadge';

const navItems = [
  { name: 'Dashboard', path: '/portal/dashboard', icon: LayoutDashboard },
  { name: 'Órdenes', path: '/portal/orders', icon: ListOrdered },
  { name: 'Webhooks', path: '/portal/webhooks', icon: Webhook },
  { name: 'Configuración', path: '/portal/settings', icon: Settings },
];

export default function MerchantLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, merchant } = useMerchantAuth();

  const handleLogout = () => {
    logout();
    toast.success('Sesión cerrada');
    navigate('/portal/login');
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--brand-sand))]" data-testid="merchant-layout">
      <header className="bg-white border-b border-[hsl(var(--border))] sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-4">
              <h1 className="text-xl font-bold text-[hsl(var(--brand-ink))]" style={{ fontFamily: 'var(--font-heading)' }}>
                FluxiPay Portal
              </h1>
              <EnvironmentBadge />
              {merchant && (
                <span className="text-sm text-[hsl(var(--muted-foreground))]">
                  {merchant.name}
                </span>
              )}
            </div>
            <Button variant="ghost" size="sm" onClick={handleLogout} data-testid="merchant-logout-btn">
              <LogOut className="w-4 h-4 mr-2" />
              Salir
            </Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8">
          <aside className="w-64 flex-shrink-0">
            <nav className="space-y-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-[hsl(var(--brand-teal))]/10 text-[hsl(var(--brand-teal))] font-medium'
                        : 'text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--accent))]'
                    }`}
                    data-testid={`merchant-nav-${item.name.toLowerCase()}`}
                  >
                    <Icon className="w-5 h-5" />
                    {item.name}
                  </Link>
                );
              })}
            </nav>
          </aside>

          <main className="flex-1" data-testid="merchant-content">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
